import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {HttpParams} from '@angular/common/http';

import {ApiService} from '../../service/api.service';
import {AuthService} from '../../service/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: []
})
export class LoginComponent implements OnInit {

    public submitted = false;

    loginForm: FormGroup;
    formObject: Object = {
        '_username': '',
        '_password': ''
    }

    constructor(private api: ApiService, private auth: AuthService) {
        this.loginForm = new FormGroup(
            {
                '_username': new FormControl('', [Validators.required]),
                '_password': new FormControl('', [Validators.required])
            }
        );
    }

    ngOnInit() {
    }

    login() {
        const body = new HttpParams()
            .set('_username', this.loginForm.value._username)
            .set('_password', this.loginForm.value._password);

        this.submitted = true;
        this.api.post('login_check', body).subscribe(
            params => {
                this.auth.initUser(params);
                this.submitted = false;
            },
            response => {
                this.loginForm.setValue(this.formObject);
                this.loginForm.controls['_password'].setErrors({login: 'invalid username/password'});
                this.submitted = false;
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/login/login.component.ts